// 导出域名
// export const domain = 'http://localhost:9090';

// 默认导出整个接口配置
export default {

  // 账号管理
  login: `bop/api/system/sysuser/login`, // 登陆
  menu: `bop/api/system/sysmenu/getnodelist`, // 菜单 // 账号管理 // 登陆
  //saveCache: ``bop/api/system/sysuser/savecache`, // 登陆成功请求
  removeSession: `bop/api/system/sysuser/kickoutuserbyname`, //请求后端超时登录时，删除对应后端的session
  logout: `bop/api/system/sysuser/logout`,
  sysUserCheckNameExists: `bop/api/system/sysuser/checknameexists/`, // {loginUser} 检查登录名是否已存在

  // 权限管理
  queryUserDataPermission: 'bop/api/system/sysuserdatapermission/queryUserDataPermission', // 查询权限
  saveUserDataPermission: 'bop/api/system/sysuserdatapermission/saveUserDataPermission', // 保存权限

  //角色管理
  roleQueryByPage: `bop/api/system/sysrole/querybypage`, //带分页的条件查找 condition没有参数则查询全部
  roleSave: `bop/api/system/sysrole/save`,
  roleDelete: `bop/api/system/sysrole/delete/`, //{id}
  roleBatchDelete: `bop/api/system/sysrole/batchdelete`,
  roleBatchUpdate: `bop/api/system/sysrole/batchupdate`,
  rolePCofingGetAllData: `bop/api/system/sysrole/pconfig/getalldata`,
  rolePConfigBatchSave: `bop/api/system/sysrole/pconfig/batchsave/`, //{roleId}
  rolePConfigGetButton: `bop/api/system/sysrole/pconfig/getbutton/`, //{id}
  queryAllRole: `bop/api/system/sysrole/queryallrole`, //{id}
  roleGenerateCode: `bop/api/system/sysrole/generatecode`,
  approleSelectById:`bop/api/system/sysrole/selectApp/`,
  approleSaveById: 'bop/api/system/sysrole/saveApp/',
  // 角色权限管理
  queryRoleDataPermission: 'bop/api/system/sysroledatapermission/queryRoleDataPermission', // 查询权限
  saveRoleDataPermission: 'bop/api/system/sysroledatapermission/saveRoleDataPermission', // 保存权限

  //菜单管理
  menuList: `bop/api/system/sysmenu/getnodelist`,
  deleteNode: `bop/api/system/sysmenu/deletenode?id=`,
  saveNode: `bop/api/system/sysmenu/savenode`,

  //按钮管理
  buttonList: `bop/api/system/sysbutton/selectbuttonlist`,
  deleteButton: `bop/api/system/sysbutton/deletebyid/`,
  updateButton: `bop/api/system/sysbutton/updatebyid`,
  insertButton: `bop/api/system/sysbutton/insert`,

  //岗位配置
  postQueryByPage: `bop/api/system/syspostbasicinfo/querybypage`, //岗位分页查询
  postSave: 'bop/api/system/syspostbasicinfo/save', //保存或新增岗位
  postDelete: 'bop/api/system/syspostbasicinfo/delete/', //{id}
  postGetOrgTree: `bop/api/system/syspostbasicinfo/getorgtree`,
  postGetAllocatedUserData: `bop/api/system/syspostbasicinfo/getallocateduserdata/`,
  postGetAllocatedRoleData: `bop/api/system/syspostbasicinfo/getallocatedroledata/`,
  postSaveUserAndRole: `bop/api/system/syspostbasicinfo/saveallocateddata`,
  postGetAllRoleData: `bop/api/system/syspostbasicinfo/getallroledata`,
  postGetAllUserData: `bop/api/system/syspostbasicinfo/getalluserdata`,
  postGenerateCode: `bop/api/system/syspostbasicinfo/generatecode`,


  //组织
  orgSave: 'bop/api/system/sysorg/save', //新增
  orgDel: 'bop/api/system/sysorg/delete/', // 删除
  orgBatchDel: 'bop/api/system/sysorg/batchdelete', //批量删除
  orgEdit: 'bop/api/system/sysorg/querybyid/', // 根据ID查询数据
  orgUpdate: 'bop/api/system/sysorg/update', // 更新
  orgList: 'bop/api/system/sysorg/querylist', // 分页查询
  orgTree: 'bop/api/system/sysorg/treesysorg', // 查询树形结构数据
  getselectorgtree: 'bop/api/system/sysorg/getselectorgtree', // 查询树形结构数据
  orgQueryByParentId: 'bop/api/system/sysorg/querybyparentid/', // 查询树形结构数据
  orgGenerateCode: 'bop/api/system/sysorg/generatecode/', // 查询树形结构数据
  getOrgTreeByStatus: 'bop/api/system/sysorg/getorgtreebystatus/', // 查询树形结构数据
  orgAllTree: 'bop/api/system/sysorg/orgalltree', // 查询全部组织数据包含（启用禁用）
  getOrgList: 'bop/api/system/sysorg/getOrgList', // 查询全部组织数据包含（启用禁用）
  getUpOrg: 'bop/api/system/sysorg/getUpOrg', // 查询最顶部组织

  //账号配置
  userSaveOrUpdate: "bop/api/system/sysuser/saveorupdate", //新增用户
  getAllUserByCondition: "bop/api/system/sysuser/querybycondition", //根据条件分页查询用户信息
  queryAllUser: "bop/api/system/sysuser/queryall", //查询所有用户
  batchUpdateStatus: "bop/api/system/sysuser/batchupdatestatus", //更新批量用户的状态
  deleteUser: "bop/api/system/sysuser/delete/", //{id}   根据id删除用户信息
  saveVerifyOldPassword: "bop/api/system/sysuser/saveverifyoldpassword", //修改用户密码
  sysUserQueryByDeptId: "bop/api/system/sysuser/querybydeptid", //根据部门id查找用户
  sysUserQueryById: "bop/api/system/sysuser/querybyid/", //根据id查找用户
  sysUserResetPasswordById: "bop/api/system/sysuser/resetpasswordbyid/", //根据id重置账号用户的密码
  sysUserUpdateUserInfo: "bop/api/system/sysuser/updateuserinfo", //更新用户基本信息(不更新密码)
  sysUserUpdateUserById: "bop/api/system/sysuser/updateuserpassbyid", //根据id更新用户密码
  userQueryHeadPortraitById: 'bop/api/system/sysuser/selectheadportraitbyid/', //根据id查询头像

  //参数配置
  sysparameterconfigurationQueryByCondition: 'bop/api/system/sysparameterconfiguration/querybycondition',//根据条件查询职称档案
  sysparameterconfigurationSaveOrUpdate: 'bop/api/system/sysparameterconfiguration/saveorupdate',//新增或保存职称档案
  sysparameterconfigurationDeleteById: 'bop/api/system/sysparameterconfiguration/deletebyid/',//根据id删除职称档案
  sysparameterconfigurationQueryall: 'bop/api/system/sysparameterconfiguration/queryall', //查询全部

  //部门
  deptSave: 'bop/api/system/sysdept/save', //新增
  deptDel: 'bop/api/system/sysdept/delete/', // 删除
  deptBatchDel: 'bop/api/system/sysdept/batchdelete', // 批量删除
  deptEdit: 'bop/api/system/sysdept/querybyid', // 根据ID查询数据
  deptUpdate: 'bop/api/system/sysdept/update', // 更新
  deptList: 'bop/api/system/sysdept/querylist', // 分页查询
  deptTree: 'bop/api/system/sysdept/treesysdept', // 查询树形结构数据
  deptTreeByOrgId: 'bop/api/system/sysdept/treesysdeptbyorgid/',
  deptGenerateCode: 'bop/api/system/sysdept/generatecode/',

  //岗位
  aictyPostSaveOrUpdate: 'bop/api/aicty/sysPost/saveOrUpdate', //新增
  postDel: 'bop/api/aicty/sysPost/deleteByPrimaryKey/', // 删除
  postEdit: 'bop/api/aicty/sysPost/querybyid', // 根据ID查询数据
  aictypostGenerateCode: 'bop/api/aicty/sysPost/generatecode/',
  postTree: 'bop/api/aicty/sysPost/treesyspost', // 查询树形结构数据
  postQueryByConditione: 'bop/api/aicty/sysPost/queryByCondition',

  //字典管理
  dicTypeSave: `bop/api/system/sysdictype/save`,
  dicTypeQueryByPage: `bop/api/system/sysdictype/querybypage`,
  dicTypeDelete: `bop/api/system/sysdictype/delete/`, //{id}
  dicTypeBatchDelete: `bop/api/system/sysdictype/bacthdelete`,
  dicTypeGetType: `bop/api/system/sysdictype/gettype/`, //{dicType}
  dicSave: `bop/api/system/sysdic/save`,
  dicQueryByPageAndDicTypeID: `bop/api/system/sysdic/querybypageanddictypeid/`, //{dicTypeId}
  dicDelete: `bop/api/system/sysdic/delete/`, //{id}
  dicBatchDelete: `bop/api/system/sysdic/batchdelete`,
  dicQueryAll: `bop/api/system/sysdic/queryAllDic`,

  //按钮配置
  buttonConfigSave: `bop/api/system/sysbuttonconfig/saveOrUpdate`,
  buttonConfigQueryByPage: `bop/api/system/sysbuttonconfig/querybycondition`,
  buttonConfigDelete: `bop/api/system/sysbuttonconfig/delete/`, //{id}
  buttonConfigBatchDelete: `bop/api/system/sysbuttonconfig/batchdelete`,

  /**
   * 基础档案
   */
  // 业态
  ProBusformatQueryTreeList: "bop/api/aicty/proBusformat/queryTreeList",
  ProBusformatSaveOrUpdate: "bop/api/aicty/proBusformat/saveOrUpdate",
  ProBusformatDeleteByPrimaryKey: "bop/api/aicty/proBusformat/deleteByPrimaryKey/",
  ProBusformatGetTree: "bop/api/aicty/proBusformat/queryTreeList",
  ProBusformatQueryByPrimaryKey: "bop/api/aicty/proBusformat/queryByPrimaryKey/",
  ProBusformatQueryEnable: "bop/api/aicty/proBusformat/queryEnabled",

  // 项目
  ProProjectQueryTreeListByOrgId: "bop/api/aicty/proProject/queryTreeList",
  ProProjectQueryTreeList: "bop/api/aicty/proProject/queryTreeList",
  ProProjectSaveOrUpdate: "bop/api/aicty/proProject/saveOrUpdate",
  ProProjectDeleteByPrimaryKey: "bop/api/aicty/proProject/deleteByPrimaryKey/",
  ProProjectGetTree: "bop/api/aicty/proProject/queryTreeList",
  ProProjectQueryByCondition: "bop/api/aicty/proProject/queryByCondition",
  //计量单位
  ProMeasureUnitQueryByCondition: "bop/api/aicty/proMeasureUnit/queryByCondition",
  ProMeasureUnitQueryByPrimaryKey: "bop/api/aicty/proMeasureUnit/queryByPrimaryKey/",
  ProMeasureUnitSaveOrUpdate: "bop/api/aicty/proMeasureUnit/saveOrUpdate",
  ProMeasureUnitDeleteByPrimaryKey: "bop/api/aicty/proMeasureUnit/deleteByPrimaryKey/",

  //中间表数据的查询
  PayLogQueryByCondition: "bop/api/wechatpaylog/payLog/queryByCondition",
  PayLogQueryByPrimaryKey: "bop/api/wechatpaylog/payLog/queryByPrimaryKey/",
  PayLogSaveOrUpdate: "bop/api/wechatpaylog/payLog/saveOrUpdate",
  PayLogDeleteByPrimaryKey: "bop/api/wechatpaylog/payLog/deleteByPrimaryKey/",
  //位置支付配置
  JsapiConfigQueryByCondition: "bop/api/ctyjsapiconfig/jsapiConfig/queryByCondition",
  JsapiConfigQueryByPrimaryKey: "bop/api/ctyjsapiconfig/jsapiConfig/queryByPrimaryKey/",
  JsapiConfigSaveOrUpdate: "bop/api/ctyjsapiconfig/jsapiConfig/saveOrUpdate",
  JsapiConfigDeleteByPrimaryKey: "bop/api/ctyjsapiconfig/jsapiConfig/deleteByPrimaryKey/",
  // 房源状态
  ProRoomstatusQueryList: "bop/api/aicty/proRoomstatus/queryByCondition",
  ProRoomstatusSaveOrUpdate: "bop/api/aicty/proRoomstatus/saveOrUpdate",
  ProRoomstatusDeleteByPrimaryKey: "bop/api/aicty/proRoomstatus/deleteByPrimaryKey/",
  ProRoomstatusQueryByPrimaryKey: "bop/api/aicty/proRoomstatus/queryByPrimaryKey/",
  ProRoomstatusQueryEnable: "bop/api/aicty/proRoomstatus/queryEnabled",
  queryHouseConStatusColor: 'bop/api/aicty/proRoomstatus/queryHouseConStatusColor',

  //短信配置
  SmsConfigQueryByCondition: "bop/api/ctysmsconfig/smsConfig/queryByCondition",
  SmsConfigQueryByPrimaryKey: "bop/api/ctysmsconfig/smsConfig/queryByPrimaryKey/",
  SmsConfigSaveOrUpdate: "bop/api/ctysmsconfig/smsConfig/saveOrUpdate",
  SmsConfigDeleteByPrimaryKey: "bop/api/ctysmsconfig/smsConfig/deleteByPrimaryKey/",
  // 房源
  ProRoomQueryList: "bop/api/aicty/proRoom/queryByCondition",
  ProRoomSaveOrUpdate: "bop/api/aicty/proRoom/saveOrUpdate",
  ProRoomDeleteByPrimaryKey: "bop/api/aicty/proRoom/deleteByPrimaryKey/",
  ProRoomQueryByPrimaryKey: "bop/api/aicty/proRoom/queryByPrimaryKey/",
  ProRoomQueryEnable: "bop/api/aicty/proRoom/queryEnabled",
  ProRoomQueryByConditionSort: "bop/api/aicty/proRoom/queryByConditionSort",
  queryUnitRoomByBuilder: "bop/api/aicty/proRoom/queryUnitRoomByBuilder/",
  ProRoomDeleteBatchByPrimaryKeys: "bop/api/aicty/proRoom/deleteBatchByPrimaryKeys",
  countRoom: "bop/api/aicty/proRoom/countRoom",
  ProRoomTreeQueryList: "bop/api/aicty/proRoom/queryRoomTree",
  ProRoomTreeLazyList: "bop/api/aicty/proRoom/queryRoomLazyList",
  ProRoomQueryRoomList: "bop/api/aicty/proRoom/queryRoomList",
  ProRoomQueryOwnerAndLiverInfo: "bop/api/aicty/proRoom/queryOwnerAndLiverInfo/",

  //富文本 图片上传
  // richUpload:'bop/ftp-pool/richUpload', //文件上传
  // imageUpload:'bop/ftp-pool/imageUpload',//图片上传

  richUpload: 'bop/api/system/sysFile/richUpload', //文件上传
  imageUpload: 'bop/api/system/sysFile/imageUpload',//图片上传


  //首页可视化图形
  // showSecretaryInfo:"bop/api/aicty/homepage/showSecretaryInfo",
  showStaffInfo: 'bop/api/aicty/homerStaff/showStaffInfo',
  showManagerInfo: 'bop/api/aicty/homerManager/showManagerInfo',
  showSecretaryInfo: 'bop/api/aicty/homerSecretary/showSecretaryInfo',


  /**
   * 社区
   */
  // 网格图
  CtyGridQueryRoomList: "bop/api/aicty/ctyGrid/queryRoomList",
  CtyGridQueryOwnerAndLiverInfo: "bop/api/aicty/ctyGrid/queryOwnerAndLiverInfo/",
  CtyGridQuerySignDetails: "bop/api/aicty/ctyGrid/querySignDetails/",

  // 网格图 管理
  GridGraphQueryByCondition: "bop/api/aicty/gridGraph/queryByCondition",
  GridGraphQueryByPrimaryKey: "bop/api/aicty/gridGraph/queryByPrimaryKey/",
  GridGraphSaveOrUpdate: "bop/api/aicty/gridGraph/saveOrUpdate",
  GridGraphDeleteByPrimaryKey: "bop/api/aicty/gridGraph/deleteByPrimaryKey/",

  //网格列表
  CtyGridQueryByCondition: "bop/api/aicty/ctyGrid/queryByCondition",
  CtyGridSaveOrUpdate: "bop/api/aicty/ctyGrid/saveOrUpdate",
  CtyGridDeleteByPrimaryKey: "bop/api/aicty/ctyGrid/deleteByPrimaryKey/",
  CtyGridGetTree: "bop/api/aicty/ctyGrid/queryTreeList",
  CtyGridDeleteBatchByPrimaryKeys: "bop/api/aicty/ctyGrid/deleteBatchByPrimaryKeys",
  CtyGridQueryEnable: "bop/api/aicty/ctyGrid/queryEnabled",
  CtyGridhouseQueryByCondition: "bop/api/aicty/ctyGridhouse/queryByCondition",

  // 党组织
  CtyPartyorgQueryTreeList: "bop/api/aicty/ctyPartyorg/queryTreeList",
  CtyPartyorgSaveOrUpdate: "bop/api/aicty/ctyPartyorg/saveOrUpdate",
  CtyPartyorgDeleteByPrimaryKey: "bop/api/aicty/ctyPartyorg/deleteByPrimaryKey/",
  CtyPartyorgGetTree: "bop/api/aicty/ctyPartyorg/queryTreeList",
  CtyPartyorgPermissionGetTree: "bop/api/aicty/ctyPartyorg/queryTreePermissionList",
  // 党内职务
  CtyPartydutyQueryTreeList: "bop/api/aicty/ctyPartyduty/queryTreeList",
  CtyPartydutySaveOrUpdate: "bop/api/aicty/ctyPartyduty/saveOrUpdate",
  CtyPartydutyDeleteByPrimaryKey: "bop/api/aicty/ctyPartyduty/deleteByPrimaryKey/",
  CtyPartydutyGetTree: "bop/api/aicty/ctyPartyduty/queryTreeList",
  // 社区党员
  CtyPartyMemberQueryByCondition: "bop/api/aicty/ctyPartyMember/queryByCondition",
  CtyPartyMemberQueryPermissionByCondition: "bop/api/aicty/ctyPartyMember/queryPermissionByCondition",
  CtyPartyMemberSaveOrUpdate: "bop/api/aicty/ctyPartyMember/saveOrUpdate",
  CtyPartyMemberBatchUpdate: "bop/api/aicty/ctyPartyMember/batchUpdate",
  CtyPartyMemberDeleteByPrimaryKey: "bop/api/aicty/ctyPartyMember/deleteByPrimaryKey/",
  CtyPartyMemberQueryByPopulId: "bop/api/aicty/ctyPartyMember/queryByPopulId/",
  // 党费基数核定
  CtyPartyformulaQueryByCondition: "bop/api/aictty/ctyPartyformula/queryByCondition",
  CtyPartyformulaQueryByPrimaryKey: "bop/api/aictty/ctyPartyformula/queryByPrimaryKey/",
  CtyPartyformulaSaveOrUpdate: "bop/api/aictty/ctyPartyformula/saveOrUpdate",
  CtyPartyformulaDeleteByPrimaryKey: "bop/api/aictty/ctyPartyformula/deleteByPrimaryKey/",
  CtyPartyformulaQueryByParameter: "bop/api/aictty/ctyPartyformula/queryByParameter",
  // 党费缴纳登记
  CtyPartycostregQueryByCondition: "bop/api/aicty/ctyPartycostreg/queryByCondition",
  CtyPartycostregQueryByPrimaryKey: "bop/api/aicty/ctyPartycostreg/queryByPrimaryKey/",
  CtyPartycostregSaveOrUpdate: "bop/api/aicty/ctyPartycostreg/saveOrUpdate",
  CtyPartycostregDeleteByPrimaryKey: "bop/api/aicty/ctyPartycostreg/deleteByPrimaryKey/",
  BatchCtyPartycostreg: "bop/api/aicty/ctyPartycostreg/batchCtyPartycostreg",
  CtyPartycostregQueryByFilterCondition: "bop/api/aicty/ctyPartycostreg/queryByFilterCondition",
  CtyPartycostregQueryReport: "bop/api/aicty/ctyPartycostreg/queryReport",

  // 人口信息
  ProPopulregisterQueryByCondition: "bop/api/aicty/proPopulregister/queryByCondition",
  CustomerDocQueryByCondition: "bop/api/aicty/proPopulregister/queryCustomerDocByCondition",
  ProPopulregisterQueryByPrimaryKey: "bop/api/aicty/proPopulregister/queryByPrimaryKey/",
  ProPopulregisterSaveOrUpdate: "bop/api/aicty/proPopulregister/saveOrUpdate",
  ProPopulregisterDeleteByPrimaryKey: "bop/api/aicty/proPopulregister/deleteByPrimaryKey/",
  ProPopulregisterQueryByRoomId: "bop/api/aicty/proPopulregister/queryPopulByRoomid",
  ProPopulregisterProBuildRoomPopulTree: "bop/api/aicty/proPopulregister/queryProBuildRoomPopulTree",
  ProPopulregisterProBuildRoomPopulTreeByHouse: "bop/api/aicty/proPopulregister/queryProBuildRoomPopulTreeByHouse",
  ProPopulregisterRegPlannedParenthood: "bop/api/aicty/proPopulregister/regPlannedParenthood",
  ProPopulregisterRegCivilAffairs: "bop/api/aicty/proPopulregister/regCivilAffairs",
  ProPopulregisterQueryByPartyMember: "bop/api/aicty/proPopulregister/queryByPartyMember",
  ProPopulregisterGenProCtypopulByBuildingId: "bop/api/aicty/proPopulregister/genProCtypopulByBuildingId/",
  ProPopulregisterExcel:"bop/api/aicty/proPopulregister/exportReceipt",
  
  //疫情反防控
  ProEpidemicQueryByCondition: "bop/api/aicty/proEpidemic/queryByCondition",
  ProEpidemicQueryByPrimaryKey: "bop/api/aicty/proEpidemic/queryByPrimaryKey/",
  ProEpidemicSaveOrUpdate: "bop/api/aicty/proEpidemic/saveOrUpdate",
  ProEpidemicDeleteByPrimaryKey: "bop/api/aicty/proEpidemic/deleteByPrimaryKey/",
  queryByConditionepidemic :"bop/api/aicty/proPopulregister/queryByConditionepidemic",
  querybatchepidemicsituation :"bop/api/aicty/proPopulregister/batchepidemicsituation/",

  // 房产客户关系
  ProHouseregisQueryByCondition: "bop/api/aicty/proHouseregis/queryByCondition",
  ProHouseregisQueryByPopulId:"bop/api/aicty/proHouseregis/queryByPopulId/",
  ProHouseregisSaveByWorkflowType: "bop/api/aicty/proHouseregis/saveHouseCustInfoByWorkflowType",
  ProHouseregisGroupByhouseId: "bop/api/aicty/proHouseregis/groupByhouseId",
  ProHouseregisGroupByhouseIdCondition: "bop/api/aicty/proHouseregis/groupByhouseIdCondition",

  // 标签档案
  ProLabelQueryTreeList: "bop/api/aicty/proLabel/queryTreeList",
  ProLabelSaveOrUpdate: "bop/api/aicty/proLabel/saveOrUpdate",
  ProLabelDeleteByPrimaryKey: "bop/api/aicty/proLabel/deleteByPrimaryKey/",
  ProLabelGetTree: "bop/api/aicty/proLabel/queryTreeList",
  ProLabelAddClz: "bop/api/aicty/proLabelclassify/saveOrUpdate",
  ProLabelDelClz: "bop/api/aicty/proLabelclassify/deleteByPrimaryKey/",
  ProLabelAddRole: "bop/api/aicty/proLabel/addLabelrole/",
  ProLabelDelRole: "bop/api/aicty/proLabel/deleteLabelrole/",
  ProLabelIsUsingFieldKey: "bop/api/aicty/proLabeldefine/isUsingFieldKey/",

  // 人口标签分配
  ProLabelallotQueryByCondition: "bop/api/aicty/proLabelallot/queryByCondition",
  ProLabelallotSaveOrUpdate: "bop/api/aicty/proLabelallot/saveOrUpdate",
  ProLabelallotDeleteByPrimaryKey: "bop/api/aicty/proLabelallot/deleteByPrimaryKey/",
  ProLabelallotGetTree: "bop/api/aicty/proLabelallot/queryTreeList",
  ProLabelallotIsPopulHasLabel: "bop/api/aicty/proLabelallot/isPopulHasLabel",
  ProLabelallotQueryLabelList: "bop/api/aicty/proLabelallot/queryLabelList",
  ProLabelallotCancelAssign: "bop/api/aicty/proLabelallot/cancelAssign",
  ProLabelallotQueryProLabeldefineByCondition: "bop/api/aicty/proLabeldefine/queryByCondition",

  //公告分类
  CtyNoticeTypeQueryTreeList: "bop/api/aicty/ctyNoticeType/queryTreeList",
  CtyNoticeTypeSaveOrUpdate: "bop/api/aicty/ctyNoticeType/saveOrUpdate",
  CtyNoticeTypeDeleteByPrimaryKey: "bop/api/aicty/ctyNoticeType/deleteByPrimaryKey/",
  CtyNoticeTypeGetTree: "bop/api/aicty/ctyNoticeType/queryTreeList",
  CtyNoticetypeQueryStatus: "bop/api/aicty/ctyNoticeType/queryTreeListByStatus",
  CtyNoticetypeQueryByPrimaryKey: "bop/api/aicty/ctyNoticeType/queryByPrimaryKey",


  //公告内容
  CtyNoticeQueryByCondition: "bop/api/aicty/ctyNotice/queryByCondition",
  CtyNoticeQueryByPrimaryKey: "bop/api/aicty/ctyNotice/queryByPrimaryKey/",
  CtyNoticeSaveOrUpdate: "bop/api/aicty/ctyNotice/saveOrUpdate",
  CtyNoticeDeleteByPrimaryKey: "bop/api/aicty/ctyNotice/deleteByPrimaryKey/",
  CtyNoticeUpdatePushStatusById: "bop/api/aicty/ctyNotice/updatePushStatusById/",
  CtyNoticeQueryPushByCondition: "bop/api/aicty/ctyNotice/queryByConditionPush",
  CtyNoticeUpdateByPrimaryKey: "bop/api/aicty/ctyNotice/updateById/",

  /**
   * 物业管理
   */
  //服务中心
  proServicenterQueryList: "bop/api/aicty/proServicenter/queryByCondition",
  proServicenterSaveOrUpdate: "bop/api/aicty/proServicenter/saveOrUpdate",
  proServicenterDeleteByPrimaryKey: "bop/api/aicty/proServicenter/deleteByPrimaryKey/",
  proServicenterQueryByPrimaryKey: "bop/api/aicty/proServicenter/queryByPrimaryKey/",
  proServicenterQueryEnable: "bop/api/aicty/proServicenter/queryEnabled",
  proServicenterGetTree: "bop/api/aicty/proServicenter/queryTreeList",


  // 收费项目
  ProCostsubjQueryList: "bop/api/aicty/proCostsubj/queryByCondition",
  ProCostsubjQueryTreeList: "bop/api/aicty/proCostsubj/queryTreeList",
  ProCostsubjSaveOrUpdate: "bop/api/aicty/proCostsubj/saveOrUpdate",
  ProCostsubjDeleteByPrimaryKey: "bop/api/aicty/proCostsubj/deleteByPrimaryKey/",
  ProCostsubjGetTree: "bop/api/aicty/proCostsubj/queryTreeList",
  ProCostsubjQueryByPrimaryKey: "bop/api/aicty/proCostsubj/queryByPrimaryKey/",
  ProCostsubjQueryEnable: "bop/api/aicty/proCostsubj/queryEnabled",

  // 收费标准
  ProCostnormQueryList: "bop/api/aicty/proCostnorm/queryByCondition",
  ProCostnormjQueryTreeList: "bop/api/aicty/proCostnorm/queryTreeList",
  ProCostnormSaveOrUpdate: "bop/api/aicty/proCostnorm/saveOrUpdate",
  ProCostnormDeleteByPrimaryKey: "bop/api/aicty/proCostnorm/deleteByPrimaryKey/",
  ProCostnormGetTree: "bop/api/aicty/proCostnorm/queryTreeList",
  ProCostnormQueryByPrimaryKey: "bop/api/aicty/proCostnorm/queryByPrimaryKey/",
  ProCostnormQueryEnable: "bop/api/aicty/proCostnorm/queryEnabled",
  ProCostnormueryByCostsubId: "bop/api/aicty/proCostnorm/queryByCostsubId/",
  ProCostnormQueryByHouseCust: "bop/api/aicty/proCostnorm/queryByHouseCust/",

  //客户收费标准
  ProCustCostnormQueryList: "bop/api/aicty/proCustCostnorm/queryByCondition",
  ProCustCostnormQueryListByHouse: "bop/api/aicty/proCustCostnorm/queryByConditionByhouse",
  ProCustCostnormQueryByPrimaryKey: "bop/api/aicty/proCustCostnorm/queryByPrimaryKey/",
  ProCustCostnormSaveOrUpdate: "bop/api/aicty/proCustCostnorm/saveOrUpdate",
  ProCustCostnormDeleteByPrimaryKey: "bop/api/aicty/proCustCostnorm/deleteByPrimaryKey/",

  //根据房客关系和收费标准查询客户收费标准
  ProCustCostnormQueryByHouseCustAndCostnorm: "bop/api/aicty/proCustCostnorm/queryByHouseCustAndCostnorm",
  ProRoomQueryByBuilderId: "bop/api/aicty/proRoom/queryByBuilderId/",

  //应用收费计算
  ProReceivcalcQueryByCondition: "bop/api/aicty/proReceivcalc/queryByCondition",
  ProReceivcalcQueryByConditionId: "bop/api/aicty/proReceivcalcB/queryByConditionById",
  ProReceivcalcQueryByPrimaryKey: "bop/api/aicty/proReceivcalc/queryByPrimaryKey/",
  ProReceivcalcSaveOrUpdate: "bop/api/aicty/proReceivcalc/saveOrUpdate",
  ProReceivcalcDeleteByPrimaryKey: "bop/api/aicty/proReceivcalc/deleteByPrimaryKey/",
  ProReceivcalcBDeleteByPrimaryKeys: "bop/api/aicty/proReceivcalcB/deleteBatchByPrimaryKeys/",
  // ProReceivcalcGeneRececalcByCondition: "bop/api/aicty/proReceivcalc/generateReceivcalcByCondition",
  //修改方案过后的
  ProReceivcalcGeneRececalcByCondition: "bop/api/aicty/proReceivcalc/getReceivcalcByCondition",
  getReceivcalcByCondition: "bop/api/aicty/proReceivcalc/getReceivcalcByCondition",
  ProReceivcalcHandleRowApprove: "bop/api/aicty/proReceivcalc/handleRowApprove",
  ProReceivcalcHandleRowUnApprove: "bop/api/aicty/proReceivcalc/handleRowUnApprove", 

  ProPopulregisterQueryByBuilderIdAndOrgId: "bop/api/aicty/proPopulregister/queryPopulByBuilderIdAndOrgId",
  //费用清单
  ProReceivableQueryByCondition: "bop/api/aicty/proReceivable/queryByCondition",
  ProReceivableQueryByPrimaryKey: "bop/api/aicty/proReceivable/queryByPrimaryKey/",
  ProReceivableSaveOrUpdate: "bop/api/aicty/proReceivable/saveOrUpdate",
  ProReceivableDeleteByPrimaryKey: "bop/api/aicty/proReceivable/deleteByPrimaryKey/",


  //应收费用清单生成调整单
  ProReceivableSaveAdjustment: "bop/api/aicty/proReceivable/saveAdjustment",
  //应收费用清单生成收款单
  ProReceivableSaveReceives: "bop/api/aicty/proReceivable/saveReceives",

  //应收费用调整单
  ProReceivadjustQueryByCondition: "bop/api/aicty/proReceivadjust/queryByCondition",
  ProReceivadjustQueryByPrimaryKey: "bop/api/aicty/proReceivadjust/queryByPrimaryKey/",
  ProReceivadjustSaveOrUpdate: "bop/api/aicty/proReceivadjust/saveOrUpdate",
  ProReceivadjustDeleteByPrimaryKey: "bop/api/aicty/proReceivadjust/deleteByPrimaryKey/",
  ProReceivadjustApproveByPrimaryKey: "bop/api/aicty/proReceivadjust/approveByPrimaryKey/",
  ProReceivadjustUnApproveByPrimaryKey: "bop/api/aicty/proReceivadjust/unApproveByPrimaryKey/",
  //收款单
  ProReceiveQueryByConditionExecl:"bop/api/aicty/proReceive/exportReceipt",
  ProReceiveQueryByCondition: "bop/api/aicty/proReceive/queryByCondition",
  ProReceiveQueryByPrimaryKey: "bop/api/aicty/proReceive/queryByPrimaryKey/",
  ProReceiveSaveOrUpdate: "bop/api/aicty/proReceive/saveOrUpdate",
  ProReceiveDeleteByPrimaryKey: "bop/api/aicty/proReceive/deleteByPrimaryKey/",
  ProReceiveChangeHandoverStatus: "bop/api/aicty/proReceive/changeHandoverStatus",
  ProReceiveHandleSaveReceive: "bop/api/aicty/proReceive/handleSaveReceive",//新增收款单操作
  ProReceiveHandleApprove: "bop/api/aicty/proReceive/handleApprove", //收款单审批操作
  ProReceiveHandleUnApprove: "bop/api/aicty/proReceive/handleUnApprove",//收款单弃审操作
  ProReceiveHandleRefund: "bop/api/aicty/proReceive/handleRefund",//生成退款单前置条件
  ProReceiveHandleSaveRefund: "bop/api/aicty/proReceive/handleSaveRefund",//新增退款单操作
  ProReceiveHandleReceiptNo: "bop/api/aicty/proReceive/handleReceiptNo",//查询单据号
  //收款交接
  ProReceiptDeliverQueryByCondition: "bop/api/aicty/proReceiptDeliver/queryByCondition",
  ProReceiptDeliverQueryByPrimaryKey: "bop/api/aicty/proReceiptDeliver/queryByPrimaryKey/",
  ProReceiptDeliverSaveOrUpdate: "bop/api/aicty/proReceiptDeliver/saveOrUpdate",
  ProReceiptDeliverDeleteByPrimaryKey: "bop/api/aicty/proReceiptDeliver/deleteByPrimaryKey/",
  ProReceiptDeliverUpdateByBillStatus: "bop/api/aicty/proReceiptDeliver/updateByBillStatus",
  //物业费台账
  ProStandingBookQueryByCondition:"bop/api/aicty/proStandingBook/queryByCondition",
  ProStandingBookReportsExportExecl:"bop/api/aicty/proStandingBook/standingbookReportsExportExecl",

  //设备管理
  //设备分类
  ProDevicetypeQueryTreeList: "bop/api/aicty/proDevicetype/queryTreeList",
  ProDevicetypeSaveOrUpdate: "bop/api/aicty/proDevicetype/saveOrUpdate",
  ProDevicetypeDeleteByPrimaryKey: "bop/api/aicty/proDevicetype/deleteByPrimaryKey/",
  ProDevicetypeGetTree: "bop/api/aicty/proDevicetype/queryTreeList",
  //设备档案
  ProDeviceQueryByCondition: "bop/api/aicty/proDevice/queryByCondition",
  ProDeviceSaveOrUpdate: "bop/api/aicty/proDevice/saveOrUpdate",
  ProDeviceDeleteByPrimaryKey: "bop/api/aicty/proDevice/deleteByPrimaryKey/",
  ProDeviceGetTree: "bop/api/aicty/proDevicesercorp/queryTreeList",
  //设备保养
  ProDeviceupkeepQueryByCondition: "bop/api/aicty/proDeviceupkeep/queryByCondition",
  ProDeviceupkeepQueryByPrimaryKey: "bop/api/aicty/proDeviceupkeep/queryByPrimaryKey/",
  ProDeviceupkeepSaveOrUpdate: "bop/api/aicty/proDeviceupkeep/saveOrUpdate",
  ProDeviceupkeepDeleteByPrimaryKey: "bop/api/aicty/proDeviceupkeep/deleteByPrimaryKey/",
  ProDeviceupkeepDeleteBatchByPrimaryKeys: "bop/api/aicty/proDeviceupkeep/deleteBatchByPrimaryKeys/",
  ProDeviceupkeepApprovalById: "bop/api/aicty/proDeviceupkeep/approvalById/",

  // 人事档案
  ProPersonQueryByCondition: "bop/api/aicty/proPerson/queryByCondition",
  ProPersonQueryByPrimaryKey: "bop/api/aicty/proPerson/queryByPrimaryKey/",
  ProPersonSaveOrUpdate: "bop/api/aicty/proPerson/saveOrUpdate",
  ProPersonDeleteByPrimaryKey: "bop/api/aicty/proPerson/deleteByPrimaryKey/",

  // 奖惩登记
  ProRewardPunishQueryByCondition: "bop/api/aicty/proRewardPunish/queryByCondition",
  ProRewardPunishQueryByPrimaryKey: "bop/api/aicty/proRewardPunish/queryByPrimaryKey/",
  ProRewardPunishSaveOrUpdate: "bop/api/aicty/proRewardPunish/saveOrUpdate",
  ProRewardPunishDeleteByPrimaryKey: "bop/api/aicty/proRewardPunish/deleteByPrimaryKey/",
  ProRewardPunishUpdateBillStatusById: "bop/api/aicty/proRewardPunish/updateBillStatusById/",

  //定时任务
  taskQueryByPage: `bop/api/system/systask/list`,
  taskActivate: `bop/api/system/systask/activateTask/`, //{jobName}/{jobGroup}
  taskResume: `bop/api/system/systask/resume/`,//{jobName}/{jobGroup}
  taskPause: `bop/api/system/systask/pause/`, //{jobName}/{jobGroup}
  taskSave: `bop/api/system/systask/save`,
  taskCronCheck: `bop/api/system/systask/checkcron?expression=`, //{expression}
  taskClassCheck: `bop/api/system/systask/checkclass?className=`, //{className}
  taskjobGroupCheck: `bop/api/system/systask/checkjobgroup?jobGroup=`, //{jobGroup}
  taskjobNameCheck: `bop/api/system/systask/checkjobname?jobName=`, //{jobName}
  taskDelete: `bop/api/system/systask/delete/`,//{jobName}/{jobGroup}
  //定时任务执行日志
  taskLogQueryByPage: `bop/api/system/systasklog/querybypage`,
  taskLogDelete: `bop/api/system/systasklog/delete/`, //
  taskLogBacthDelete: `bop/api/system/systasklog/bacthdelete`,
  taskLogEmptyTaskLog: `bop/api/system/systasklog/empty/`, //{taskId}

  //服务器资源信息管理
  sysSmbList: `bop/api/system/syssmb/querylist`,
  sysSmbSaveOrUpdate: `bop/api/system/syssmb/saveorupdate`,
  sysSmbDeleteById: 'bop/api/system/syssmb/delete/',  //{id}
  sysSmbUpdateById: 'bop/api/system/syssmb/updatestatusbyid/',  //{id}
  queryDefaultSmb: 'bop/api/system/syssmb/querydefaultsmb/',  //{status}
  sysSmbQueryByName: 'bop/api/system/syssmb/querybyname/',  //{name}

  //服务器系统监控
  getCpuList: `bop/api/system/systemmonitor/getcpulist`,
  getMemList: `bop/api/system/systemmonitor/getmemlist`,
  getSysFileList: `bop/api/system/systemmonitor/getsysfilelist`,
  getSysList: `bop/api/system/systemmonitor/getsyslist`,
  getJvmList: `bop/api/system/systemmonitor/getjvmlist`,

  //操作日志
  LogQuery: `bop/api/system/sysuserlog/query`, // 查询
  LogDelete: `bop/api/system/sysuserlog/batchdelete`, // 批量删除

  //登录日志
  LoginGetuser: `bop/api/system/sysloginlog/query`, //查询
  LoginDelete: `bop/api/system/sysloginlog/batchdelete`, //批量删除
  LoginUpdateLoginLog: `bop/api/system/sysloginlog/updateLoginLog`, //更新用户登录日志


  //权限验证规则串配置
  getFilterList: "bop/api/system/shiroini/getfilterlist",
  queryIniAll: "bop/api/system/shiroini/queryall",
  queryIniByFilterName: "bop/api/system/shiroini/querybyfiltername/",
  shiroIniSaveOrUpdate: "bop/api/system/shiroini/saveorupdate",
  shiroIniBatchSaveOrUpdate: "bop/api/system/shiroini/batchsaveorupdate",
  shiroIniDeleteById: "bop/api/system/shiroini/deletebyid/",
  shiroIniBatchDeleteById: "bop/api/system/shiroini/batchdeletebyid",
  shiroIniOpenOrClosePermission: "bop/api/system/shiroini/openorclosepermission/",

  //资讯信息
  infomationDel: 'bop/api/system/informationmanager/delete/', // 删除
  infomationBatchDel: 'bop/api/system/informationmanager/batchdelete', //批量删除
  infomationUpdate: 'bop/api/system/informationmanager/update', // 更新
  infomationList: 'bop/api/system/informationmanager/querybycondition', // 带条件分页查询
  infomationAll: 'bop/api/system/informationmanager/queryall', // 分页查询
  infomationQueryById: 'bop/api/system/informationmanager/querybyid/', // id查询
  infomationUpdateIssue: 'bop/api/system/informationmanager/batchupdateissue', // id查询

  // 消息服务
  sysMessageMarkMessage: 'bop/api/system/sysmessage/mark-message',
  sysMessageFindMessageEvenBroadcast: 'bop/api/system/sysmessage/find-message-even-broadcast',
  sysMessageCountMessageQuietly: 'bop/api/system/sysmessage/count-message-quietly',

  //自定义爬虫
  customWebMagic: 'bop/api/system/syswebmagic/customWebmagic',


  // 合同外原因使用ExcelUitls导出
  contractReasonDeleteById: 'bop/api/system/contractoutreason/delete/', //
  contractReasonQueryById: 'bop/api/system/contractoutreason/query/', // 根据id查询
  contractReasonSaveOrUpdate: 'bop/api/system/contractoutreason/saveorupdate', // 新增or更新
  contractReasonQueryByCondition: 'bop/api/system/contractoutreason/querybycondition ', // 分页查询
  contractReasonGenerateCode: 'bop/api/system/contractoutreason/generatecode ',
  contractReasonQueryByEnabled: "bop/api/system/contractoutreason/queryallbyenabled",//根据状态查询合同外原因单据信息


  //系统公告
  noticeQueryAll: 'bop/api/system/notice/queryall/', //查询全部公告
  noticeSaveOrUpdate: 'bop/api/system/notice/saveorupdate', //新增 or 更新公告


  //---------------------我的工作 start----------------------

  //项目日志
  projectLogQueryByCondition: 'bop/api/system/projectlog/querybycondition', //根据条件查询项目日志
  projectLogDeleteById: 'bop/api/system/projectlog/deletebyid/', //根据id删除，
  projectLogSaveOrUpdate: 'bop/api/system/projectlog/saveorupdate', //新增或更新项目日志、
  projectLogGeneratecode: 'bop/api/system/projectlog/generatecode',    //生成编码

  //---------------------我的工作 end----------------------


  //---------------------人力资源管理 start----------------------

  //职称档案
  titleArchivesQueryByCondition: 'bop/api/system/titlearchives/querybycondition',//根据条件查询职称档案
  titleArchivesSaveOrUpdate: 'bop/api/system/titlearchives/saveorupdate',//新增或保存职称档案
  titleArchivesDeleteById: 'bop/api/system/titlearchives/deletebyid/',//根据id删除职称档案
  titleArchivesGeneratecode: 'bop/api/system/titlearchives/generatecode',    //生成编码
  titleArchivesQueryall: 'bop/api/system/titlearchives/queryall', //查询全部


  //楼栋档案
  ProBuilderQueryByCondition: "bop/api/aicty/proBuilder/queryByCondition",
  ProBuilderSaveOrUpdate: "bop/api/aicty/proBuilder/saveOrUpdate",
  ProBuilderDeleteByPrimaryKey: "bop/api/aicty/proBuilder/deleteByPrimaryKey/",
  ProBuilderGetTree: "bop/api/aicty/proBuilder/queryTreeList",
  ProBuilderGetProjectName: "bop/api/aicty/proBuilder/queryProjectName",
  deleteBatchByPrimaryKeys: "bop/api/aicty/proBuilder/deleteBatchByPrimaryKeys",
  ProBuilderQueryTreeList: "bop/api/aicty/proBuilder/queryTreeList",
  ProBuilderQueryTreeListByProjectId: "bop/api/aicty/proBuilder/queryTreeListByProjectId",
  ProBuilderQueryByProjectId: "bop/api/aicty/proBuilder/queryByProjectId/",
  queryFiltrServicebuild: "bop/api/aicty/proBuilder/queryFiltrServicebuild/",
  queryByConditionPrinting:"bop/api/aicty/proPopulregister/queryByConditionPrinting",
  //企业档案
  CtyEnterpriseQueryByCondition: "bop/api/aicty/ctyEnterprise/queryByCondition",
  CtyEnterpriseQueryByPrimaryKey: "bop/api/aicty/ctyEnterprise/queryByPrimaryKey/",
  CtyEnterpriseSaveOrUpdate: "bop/api/aicty/ctyEnterprise/saveOrUpdate",
  CtyEnterpriseDeleteByPrimaryKey: "bop/api/aicty/ctyEnterprise/deleteByPrimaryKey/",
  deleteEnterpriseByPrimaryKeys: "bop/api/aicty/ctyEnterprise//deleteBatchByPrimaryKeys",

  //事件类型
  CtyEventtypeQueryTreeList: "bop/api/aicty/ctyEventtype/queryTreeList",
  CtyEventtypeSaveOrUpdate: "bop/api/aicty/ctyEventtype/saveOrUpdate",
  CtyEventtypeDeleteByPrimaryKey: "bop/api/aicty/ctyEventtype/deleteByPrimaryKey/",
  CtyEventtypeGetTree: "bop/api/aicty/ctyEventtype/queryTreeList",
  CtyEventtypeQueryEnable: "bop/api/aicty/ctyEventtype/queryEnabled",
  CtyEventtypeQueryByPrimaryKey: "bop/api/aicty/ctyEventtype/queryByPrimaryKey/",

  //事件登记
  CtyEventregisterQueryByCondition: "bop/api/aicty/ctyEventregister/queryByCondition",
  CtyEventregisterQueryByPrimaryKey: "bop/api/aicty/ctyEventregister/queryByPrimaryKey/",
  CtyEventregisterSaveOrUpdate: "bop/api/aicty/ctyEventregister/saveOrUpdate",
  CtyEventregisterDeleteByPrimaryKey: "bop/api/aicty/ctyEventregister/deleteByPrimaryKey/",
  CtyEventtypeQueryByCondition: 'bop/api/aicty/ctyEventtype/queryByCondition',
  CtyEventtypeEventTransfer :"bop/api/aicty/ctyEventregister/eventTransfer",

  //计生,民政事项登记
  CtyEventinfoQueryByCondition: "bop/api/aicty/ctyEventinfo/queryByCondition",
  CtyEventinfoQueryByPrimaryKey: "bop/api/aicty/ctyEventinfo/queryByPrimaryKey/",
  CtyEventinfoSaveOrUpdate: "bop/api/aicty/ctyEventinfo/saveOrUpdate",
  CtyEventinfoDeleteByPrimaryKey: "bop/api/aicty/ctyEventinfo/deleteByPrimaryKey/",

  //计生特殊家庭信息
  CtySpecialfamilyQueryByCondition: "bop/api/aicty/ctySpecialfamily/queryByCondition",
  CtySpecialfamilyQueryByPrimaryKey: "bop/api/aicty/ctySpecialfamily/queryByPrimaryKey/",
  CtySpecialfamilySaveOrUpdate: "bop/api/aicty/ctySpecialfamily/saveOrUpdate",
  CtySpecialfamilyDeleteByPrimaryKey: "bop/api/aicty/ctySpecialfamily/deleteByPrimaryKey/",

  //退役军人及军属档案
  CtyRetireSoldierQueryByCondition: "bop/api/aicty/ctyRetireSoldier/queryByCondition",
  CtyRetireSoldierQueryByPrimaryKey: "bop/api/aicty/ctyRetireSoldier/queryByPrimaryKey/",
  CtyRetireSoldierSaveOrUpdate: "bop/api/aicty/ctyRetireSoldier/saveOrUpdate",
  CtyRetireSoldierDeleteByPrimaryKey: "bop/api/aicty/ctyRetireSoldier/deleteByPrimaryKey/",

   //低保发放详单
   ctyLowincomeQueryByCondition: "bop/api/aicty/ctyLowincome/queryByCondition",
   ctyLowincomeQueryByPrimaryKey: "bop/api/aicty/ctyLowincome/queryByPrimaryKey/",
   ctyLowincomeSaveOrUpdate: "bop/api/aicty/ctyLowincome/saveOrUpdate",
   ctyLowincomeDeleteByPrimaryKey: "bop/api/aicty/ctyLowincome/deleteByPrimaryKey/",

  //残疾人名单
  CtyDisabledPeopleQueryByCondition: "bop/api/aicty/ctyDisabledPeople/queryByCondition",
  CtyDisabledPeopleQueryTreeList: "bop/api/aicty/ctyDisabledPeople/queryTreeList",
  CtyDisabledPeopleQueryByPrimaryKey: "bop/api/aicty/ctyDisabledPeople/queryByPrimaryKey/",
  CtyDisabledPeopleSaveOrUpdate: "bop/api/aicty/ctyDisabledPeople/saveOrUpdate",
  CtyDisabledPeopleDeleteByPrimaryKey: "bop/api/aicty/ctyDisabledPeople/deleteByPrimaryKey/",


  //工单分类
  ProWorkorderTypeQueryTreeList: "bop/api/aicty/proWorkorderType/queryTreeList",
  ProWorkorderTypeSaveOrUpdate: "bop/api/aicty/proWorkorderType/saveOrUpdate",
  ProWorkorderTypeDeleteByPrimaryKey: "bop/api/aicty/proWorkorderType/deleteByPrimaryKey/",
  ProWorkorderTypeGetTree: "bop/api/aicty/proWorkorderType/queryTreeList",
  ProWorkorderTypeQueryEnable: "bop/api/aicty/proWorkorderType/queryEnabled",
  ProWorkorderTypeQueryByPrimaryKey: "bop/api/aicty/proWorkorderType/queryByPrimaryKey/",
  ProWorkorderTypeQueryLast: "bop/api/aicty/proWorkorderType/queryLast/",
  //服务项目
  ProServiceProjectQueryByCondition: "bop/api/aicty/proServiceProject/queryByCondition",
  ProServiceProjectSaveOrUpdate: "bop/api/aicty/proServiceProject/saveOrUpdate",
  ProServiceProjectDeleteByPrimaryKey: "bop/api/aicty/proServiceProject/deleteByPrimaryKey/",
  ProServiceProjectGetTree: "bop/api/aicty/proWorkorderType/queryTreeList",
  ProServiceProjectQueryByWorkTypeId: "bop/api/aicty/proServiceProject/queryByWorkTypeId/",

  //服务工单
  ProServiceWorkQueryByCondition: "bop/api/aicty/proServiceWork/queryByCondition",
  ProServiceWorkQueryByPrimaryKey: "bop/api/aicty/proServiceWork/queryByPrimaryKey/",
  ProServiceWorkSaveOrUpdate: "bop/api/aicty/proServiceWork/saveOrUpdate",
  ProServiceWorkDeleteByPrimaryKey: "bop/api/aicty/proServiceWork/deleteByPrimaryKey/",
  ProServiceWorkSaveReceivableByService: "bop/api/aicty/proServiceWork/saveReceivableByService",

  //执业资格分类
  practiceQueryByCondition: 'bop/api/system/practiceclassification/querybycondition',//根据条件查询执业资格分类
  practiceSaveOrUpdate: 'bop/api/system/practiceclassification/saveorupdate',//新增或保存执业资格分类
  practiceDeleteById: 'bop/api/system/practiceclassification/deletebyid/',//根据id删除执业资格分类
  practiceGeneratecode: 'bop/api/system/practiceclassification/generatecode',    //生成编码
  practiceQueryall: 'bop/api/system/practiceclassification/queryall', //查询全部

  //业务岗位分类
  postQueryByCondition: 'bop/api/system/postclassification/querybycondition',//根据条件查询业务岗位分类
  postSaveOrUpdate: 'bop/api/system/postclassification/saveorupdate',//新增或保存业务岗位分类
  postDeleteById: 'bop/api/system/postclassification/deletebyid/',//根据id删除业务岗位分类
  postGeneratecode: 'bop/api/system/postclassification/generatecode',  //生成编码
  posteQueryall: 'bop/api/system/postclassification/queryall', //查询全部

  //人事信息登记
  personQueryByCondition: 'bop/api/system/personnelinformation/querybycondition',//根据条件查询业务岗位分类
  personSaveOrUpdate: 'bop/api/system/personnelinformation/saveorupdate',//新增或保存业务岗位分类
  personDeleteById: 'bop/api/system/personnelinformation/deletebyid/',//根据id删除业务岗位分类
  personGeneratecode: 'bop/api/system/personnelinformation/generatecode',  //生成编码
  personQueryall: 'bop/api/system/personnelinformation/queryall', //查询全部
  personAdduser: 'bop/api/system/personnelinformation/saveorupdatebyusername', //生成账号
  //---------------------人力资源管理 end----------------------




  //---------------------- 知识产权 start --------------------------

  //附件中心
  accessoryclassifyQueryAll: 'bop/api/system/accessoryclassify/queryall',    //查询全部附件分类
  accessoryclassifySaveOrUpdate: 'bop/api/system/accessoryclassify/saveorupdate',  //新增 or 更新
  accessoryclassifyDeleteById: 'bop/api/system/accessoryclassify/deletebyid/',   //根据id删除


  //附件管理
  accessoryInfoQueryByCondition: 'bop/api/system/accessoryinfo/querybycondition',   //根据条件查询
  accessoryInfoQueryByClassifyId: 'bop/api/system/accessoryinfo/querybyclassifyid/', //根据分类Id查找附件
  accessoryInfoQueryByBusinessId: 'bop/api/system/accessoryinfo/querybybusinessid/', //根据业务Id查找附件
  accessoryInfoUploadFile: 'bop/api/system/accessoryinfo/uploadfile', //上传文件
  accessoryInfoDownloadFile: 'bop/api/system/accessoryinfo/downloadfile', //下载文件
  accessoryInfoSave: 'bop/api/system/accessoryinfo/save', // 保存附件
  accessoryInfoDelete: 'bop/api/system/accessoryinfo/delete', // 删除附件，供各业务接口使用

  //文档分类管理
  docClassifyQueryAll: 'bop/api/system/docclassify/queryall',
  docClassifySaveOrUpdate: 'bop/api/system/docclassify/saveorupdate',
  docClassifyDeleteById: 'bop/api/system/docclassify/deletebyid/',

  //文档管理
  docInfoQueryByCondition: 'bop/api/system/docinfo/querybycondition',   //根据条件查询
  docInfoQueryByClassifyId: 'bop/api/system/docinfo/querybyclassifyid/',   //根据条件查询
  docInfoSave: 'bop/api/system/docinfo/save',
  docInfoDelete: 'bop/api/system/docinfo/delete',

  //---------------------- 知识产权 end --------------------------

  // 号段范围配置
  rangeQueryList: 'bop/api/system/sysnumberrange/queryList',
  rangeSave: 'bop/api/system/sysnumberrange/save',
  deleteRange: 'bop/api/system/sysnumberrange/deleteRange',

  // 号段范围配置详情
  rangeQueryDetailList: 'bop/api/system/sysnumberrangedetail/queryList',
  rangeDetailSaveList: 'bop/api/system/sysnumberrangedetail/save', // 批量保存子表
  generateBillNumber: 'bop/api/system/sysnumberrangedetail/generateBillNumber', // 根据号段编码和分组获取当前号码
  deleteRangeDetail: 'bop/api/system/sysnumberrangedetail/deleteRangeDetail', // 根据主键删除表体数据

  // 下拉参照
  queryPersonTree: 'bop/api/system/sysTreeRefer/queryPersonTree', // 查询人员档案，层级是组织，部门，人员


  //文件模板
  filetemplateQueryByCondition: 'bop/api/system/sysfiletemplate/querybycondition', //根据条件查询
  filetemplateDeleteById: 'bop/api/system/sysfiletemplate/deletebyid/',            //根据id删除
  filetemplateDownloadFile: 'bop/api/system/sysfiletemplate/downloadfile',       //下载
  filetemplateUploadFile: 'bop/api/system/sysfiletemplate/uploadFile/',         //上传
  filetemplateSaveOrUpdate: 'bop/api/system/sysfiletemplate/saveorupdate',       //更新
  filetemplateGeneratecode: 'bop/api/system/sysfiletemplate/generatecode',    //生成编码

  //------------------------流程审批接口 start------------------------

  deleteDeploy: `bop/api/sysactivity/activity/deletedeploy`,  //删除流程
  deploy: `bop/api/sysactivity/activity/deploy`,  //部署启动流程
  finalMyTask: `bop/api/sysactivity/activity/finalmytask`,  //完成我的任务
  queryActiviDes: `bop/api/sysactivity/activity/queryactivides`,  //查看流程审批信息
  queryPic: `bop/api/sysactivity/activity/querypic`,  //通过流程实例ID processInstanceId 查看流程图
  queryTask: `bop/api/sysactivity/activity/querytask`, //查看我的任务
  rollBackToAssignWorkFlow: `bop/api/sysactivity/activity/rollbacktoassignworkflow`, //流程退回/驳回到指定节点
  //rollbackworkflow:`bop/api/sysactivity/activity/rollbackworkflow`, //回退流程
  toAssigneeTask: `bop/api/sysactivity/activity/toassigneetask`, //流程审批指派

  //------------------------流程审批接口 end------------------------

  activitiQueryUserByRoleName: `bop/api/sysactivity/activity/queryroleusers`,// 查询角色用户

  //-------------------------- PageOffice start --------------------------
  pageOfficeQueryfiletype: "bop/api/system/pageoffice/queryfiletype/", //查询文件类型
  //-------------------------- PageOffice end --------------------------

  //---------------------测试 start----------------------

  testExeclExport: 'bop/api/system/execl/execlexport',//导出
  poiExeclExport: 'bop/api/system/syspoi/fileexport',
  poiExeclExportByTitle: 'bop/api/system/syspoi/fileexportbytitle',

  //---------------------测试 end----------------------


  informationmanagerQueryByCondition: `bop/api/system/informationmanager/querybycondition`, //咨询管理

  //---------------------研发设计 start----------------------

  desDataModelQueryByCondition: `bop/api/datamodel/sysdatamodel/querybycondition`, // 根据条件查询数据模型
  desDataModelSaveOrUpdate: `bop/api/datamodel/sysdatamodel/saveorupdate`, // 根据条件查询数据模型
  desDataModelDelete: `bop/api/datamodel/sysdatamodel/delete/`, // 根据条件查询数据模型
  desDataModelGet: `bop/api/datamodel/sysdatamodel/get/`, // 根据条件查询数据模型
  desDataModelSync: `bop/api/datamodel/sysdatamodel/sync/`, // 根据条件查询数据模型
  desDataModelGenByTable: `bop/api/datamodel/sysdatamodel/genbytable/`, // 根据tableName生成数据模型

  desDataModelQueryData: `bop/api/datamodel/sysdatamodel/querydata`, // 查询数据

  DataModelQueryByCondition: `bop/api/datamodel/sysdatamodel/querybycondition`, // 根据条件查询数据模型
  DataModelDeleteByPrimaryKey: `bop/api/datamodel/sysdatamodel/delete/`, // 根据条件查询数据模型
  DataModelSaveOrUpdate: `bop/api/datamodel/sysdatamodel/saveorupdate`, // 根据条件查询数据模型
  DataModelQueryByPrimaryKey: `bop/api/datamodel/sysdatamodel/get/`, // 根据条件查询数据模型

  // // begin test-only

  SysPostBasicInfoQueryByCondition: `bop/api/system/syspostbasicinfo/querybypage`, //岗位分页查询
  SysPostBasicInfoSaveOrUpdate: 'bop/api/system/syspostbasicinfo/save', //保存或新增岗位
  SysPostBasicInfoDeleteByPrimaryKey: 'bop/api/system/syspostbasicinfo/delete/', //{id}
  SysPostBasicInfoGetTree: `bop/api/system/syspostbasicinfo/getorgtree`,
  // SysPostBasicInfoGetAllocatedUserData:`bop/api/system/syspostbasicinfo/getallocateduserdata/`,
  // SysPostBasicInfoGetAllocatedRoleData:`bop/api/system/syspostbasicinfo/getallocatedroledata/`,
  // SysPostBasicInfoSaveUserAndRole:`bop/api/system/syspostbasicinfo/saveallocateddata`,
  // SysPostBasicInfoGetAllRoleData:`bop/api/system/syspostbasicinfo/getallroledata`,
  // SysPostBasicInfoGetAllUserData:`bop/api/system/syspostbasicinfo/getalluserdata`,
  SysPostBasicInfoGenerateCode: `bop/api/system/syspostbasicinfo/generatecode`,

  ProjectStockTypeQueryByCondition: `bop/api/gzhc/projectStockType/queryTreeList`, // 根据条件查询数据模型
  ProjectStockTypeQueryByPrimaryKey: `bop/api/gzhc/projectStockType/queryByPrimaryKey/`, // 根据条件查询数据模型
  ProjectStockTypeSaveOrUpdate: `bop/api/gzhc/projectStockType/saveOrUpdate`, // 根据条件查询数据模型
  ProjectStockTypeDeleteByPrimaryKey: `bop/api/gzhc/projectStockType/deleteByPrimaryKey/`, // 根据条件查询数据模型
  ProjectStockTypeQueryTreeList: `bop/api/gzhc/projectStockType/queryTreeList`, // 根据条件查询数据模型

  ProjectStockRecordQueryByCondition: `bop/api/gzhc/projectStockRecord/queryByCondition`, // 根据条件查询数据模型
  ProjectStockRecordGetTree: `bop/api/gzhc/projectStockType/queryTreeList`, // 根据条件查询数据模型
  ProjectStockRecordSaveOrUpdate: `bop/api/gzhc/projectStockRecord/saveOrUpdate`, // 根据条件查询数据模型
  ProjectStockRecordDeleteByPrimaryKey: `bop/api/gzhc/projectStockRecord/deleteByPrimaryKey/`, // 根据条件查询数据模型

  ProjectStockTypeGetTree: `bop/api/gzhc/projectStockType/queryTreeList`, // 根据条件查询数据模型

  // // end test-only

  //---------------------研发设计 end----------------------


  //字段类型维护
  fieldTypeQueryByCondition: 'bop/api/system/fieldtype/querybycondition',//根据条件查询
  fieldTypeSave: 'bop/api/system/fieldtype/save',//新增
  fieldTypeDeleteById: 'bop/api/system/fieldtype/deletebyid/',//根据id删除
  fieldTypeGeneratecode: 'bop/api/system/fieldtype/generatecode',  //生成编码
  fieldTypeeQueryall: 'bop/api/system/fieldtype/queryall', //查询全部


  sysFunctionQueryDatabase: 'bop/api/system/sysFunction/queryDatabase',  //查询数据库表
  sysFunctionQueryDatabaseColumn: 'bop/api/system/sysFunction/queryDatabaseColumn',  //通过表名称查询数据库表字段
  saveSysFunction: 'bop/api/system/sysFunction/saveOrUpdate', //保存
  querySysFunctionList: 'bop/api/system/sysFunction/queryByCondition', //列表查询
  querySysFunctionByPrimaryKey: 'bop/api/system/sysFunction/queryByPrimaryKey/', //根据ID查询数据
  deleteySysFunctionByPrimaryKey: 'bop/api/system/sysFunction/deleteByPrimaryKey/', //根据ID删除数据
  toCreateCode: 'bop/api/system/sysFunction/toCreateCode/', //生成代码接口
  toCreateCode4Frontend: 'bop/api/system/sysFunction/toCreateCode4Frontend/', //生成代码接口
  openFileDialog: 'bop/api/system/sysFunction/openFileDialog', //文件选择器
  sysPageFieldGenerateCode: 'bop/api/gzhc/sysPageField/generateCode', //生成前端代码
  queryByStatusSmb: 'bop/api/system/syssmb/querydefaultsmb/', // 查询默认服务器


  //影像扫描类型
  imageScanTypeQueryByCondition: `bop/api/system/imagescantype/querybycondition`,
  imageScanTypeDelete: `bop/api/system/imagescantype/delete/`, //{id}
  imageScanTypeSaveOrUpdate: `bop/api/system/imagescantype/saveorupdate`,
  imageScanTypeQueryById: `bop/api/system/imagescantype/query/`, // {id}
  imageScanTypeQueryAllTree: `bop/api/system/imagescantype/queryall`,
  imageScanTypeQueryByOrgId: `bop/api/system/imagescantype/querybyorgid/`,
  imageScanTypeGenerateCode: `bop/api/system/imagescantype/generatecode/`, //根据父级id生成子级编码
  imageScanTypeQueryByEnabledStatus: `bop/api/system/imagescantype/queryenabled`,
  //影像扫描列搜索
  imageScanqueryformanager: 'bop/api/system/imagescantype/queryformanager',

  //影像管理
  savePic: 'bop/api/system/sysocx/savepic',  //保存高拍仪拍照的图片

  // 影像管理2 // 跨浏览器控件SDK2.3.0
  savePic2: 'bop/api/system/sysocx/savepic2',  //保存高拍仪拍照的图片
  sysOcx2QueryByBusinessId: 'bop/api/system/sysocx/queryByBusinessId/',  //根据业务ID查询影像信息
  sysOcx2DeleteById: 'bop/api/system/sysocx/deletebyid/',  //删除影像
  sysOcx2DeleteByIds: 'bop/api/system/sysocx/deletebyids/',  //批量删除影像
  sysOcx2QueryForManager: 'bop/api/system/sysocx/queryformanager',  //查询影像
  sysOcx2QueryForSourceBillTypeNameFilter: 'bop/api/system/sysocx/queryforsourcebilltypenamefilter',  //查询来源单据类型

  // 在线用户
  SysUserQueryByCondition: 'bop/api/system/sysuser/queryByConditionForMonitoring', // 查询用户在线情况
  SysUserCountForUsers: 'bop/api/system/sysuser/countForUsers', // 统计用户在线情况

  dataImportImportExcel: 'bop/api/system/data-import/import-excel', // 导入Excel
  dataImportPreImportExcel: 'bop/api/system/data-import/pre-import-excel', // 导入Excel前测试转换

  //FastDFS大文件下载
  sySFileDownload: 'bop/api/system/sysFile/fileDownload', //下载
}



// WEBPACK FOOTER //
// ./src/api/api-config.js